module.exports = __webpack_public_path__ + "img/news.ef445441.svg";